import React, {useState, useRef} from 'react';
import {API, authFetch} from '../utils/api';
import DamageCheckMap from './DamageCheckMap';
import AuctionPaintMap from './AuctionPaintMap';

// 업체가 직접 검차 정보 입력 (eval_results 미연동 차량용)
// value: { paintData: {...}, damageData: {...}, score: number, isAccidentFree: bool }
// onChange: (newValue) => void
// carId: AuctionListingModal Step 1 selectedCarId (Wave 2b — 엔진 동영상 즉시 업로드용)
//
// 2026-05-10 UX 개편 (Kyle 피드백):
//   - 도막 11 grid 숫자 input → AuctionPaintMap 그림 클릭 modal (헤이딜러 스타일)
//   - 4면도 한 줄 → DamageCheckMap 입력 모드 4 탭 switcher (Wave 3)
// 2026-05-10 Wave 2b — 엔진 동영상 업로드 섹션 추가 (즉시 업로드 → car_photos INSERT)

function AuctionSelfInspection(props){
  var value=props.value||{};
  var onChange=props.onChange;
  var carId=props.carId;
  // Wave R8.2 (2026-05-20) — RFQ 출품에서는 carId 없음 → 엔진 영상 섹션 숨김
  var hideEngineVideo=props.hideEngineVideo===true;
  var paintData=value.paintData||{};
  var damageData=value.damageData||{};
  var isAccidentFree=value.isAccidentFree===true;
  var score=(value.score===0||value.score)?String(value.score):'';

  var emit=function(patch){
    if(!onChange)return;
    onChange(Object.assign({paintData:paintData,damageData:damageData,isAccidentFree:isAccidentFree,score:value.score},patch));
  };

  var updatePaint=function(next){
    emit({paintData:next||{}});
  };

  var updateDamage=function(newDmg){
    var nextDmg=newDmg||{};
    // 사고 마커 추가 시 자동으로 isAccidentFree=false (모순 방지)
    if(Object.keys(nextDmg).length>0&&isAccidentFree){
      emit({damageData:nextDmg,isAccidentFree:false});
    }else{
      emit({damageData:nextDmg});
    }
  };

  // 무사고 토글 — true 시 damageData 자동 비움 (모순 방지). 옵션 D Wave 3.
  var toggleAccidentFree=function(){
    var next=!isAccidentFree;
    emit({isAccidentFree:next,damageData:next?{}:damageData});
  };

  var updateScore=function(s){
    var raw=String(s||'').replace(/[^0-9]/g,'');
    if(raw===''){emit({score:undefined});return}
    var n=parseInt(raw)||0;
    if(n<0)n=0;if(n>100)n=100;
    emit({score:n});
  };

  return (
    <div style={{display:'flex',flexDirection:'column',gap:12}}>
      {/* 무사고 토글 — 옵션 D Wave 3. damage 마커 OR 무사고 명시 둘 중 하나 필수 (백엔드 가드와 정합). */}
      <button type="button" onClick={toggleAccidentFree}
        style={{padding:'12px 14px',background:isAccidentFree?'#dcfce7':'#f8fafc',border:'2px solid '+(isAccidentFree?'#16a34a':'#cbd5e1'),borderRadius:8,fontSize:13,fontWeight:700,color:isAccidentFree?'#15803d':'#475569',cursor:'pointer',display:'flex',alignItems:'center',justifyContent:'space-between'}}>
        <span>{isAccidentFree?'✓ 무사고 차량':'☐ 무사고 차량으로 등록'}</span>
        <span style={{fontSize:10,color:'#94a3b8',fontWeight:500}}>{isAccidentFree?'사고 부위 미입력 OK':'또는 아래 4면도에 마킹'}</span>
      </button>

      {/* 도막 측정 — 헤이딜러 스타일 그림 클릭 입력 (2026-05-10 UX 개편) */}
      <div style={{padding:'12px',background:'#f8fafc',borderRadius:8,border:'1px solid #e2e8f0'}}>
        <div style={{fontSize:11,fontWeight:700,color:'#475569',marginBottom:8,display:'flex',alignItems:'center',justifyContent:'space-between',flexWrap:'wrap',gap:4}}>
          <span>🎨 도막 측정 (부위 클릭)</span>
          <span style={{fontSize:9,color:'#94a3b8',fontWeight:500}}>11 부위 · 단계 또는 μm 입력</span>
        </div>
        <AuctionPaintMap value={paintData} onChange={updatePaint}/>
      </div>

      {/* 사고 부위 4면도 (edit 모드) */}
      <div style={{padding:'12px',background:'#f8fafc',borderRadius:8,border:'1px solid #e2e8f0'}}>
        <div style={{fontSize:11,fontWeight:700,color:'#475569',marginBottom:8}}>🔧 사고 부위 (탭해서 마킹)</div>
        <DamageCheckMap value={damageData} onChange={updateDamage} readOnly={false}/>
      </div>

      {/* 엔진 동영상 (Wave 2b — 2026-05-10) — 즉시 업로드 → car_photos INSERT */}
      {/* 2026-05-10 hotfix (advisor #1) — key={carId} 차량 변경 시 강제 remount.
          이전 차량의 uploaded state 잔존 + cross-car DELETE 위험 차단.
          Wave R8.2 (2026-05-20) — RFQ 출품에서는 hideEngineVideo=true (carId 없음) */}
      {!hideEngineVideo && <EngineVideoSection key={carId||'none'} carId={carId}/>}

      {/* 종합 점수 */}
      <div style={{padding:'12px',background:'#f8fafc',borderRadius:8,border:'1px solid #e2e8f0',display:'flex',alignItems:'center',gap:10,flexWrap:'wrap'}}>
        <div style={{fontSize:11,fontWeight:700,color:'#475569'}}>⭐ 종합 점수 (0~100)</div>
        <input type="text" inputMode="numeric"
          value={score}
          onChange={function(e){updateScore(e.target.value)}}
          placeholder="95"
          style={{width:80,padding:'6px 10px',border:'1px solid #cbd5e1',borderRadius:6,fontSize:14,fontWeight:700,textAlign:'center',outline:'none'}}/>
        <div style={{fontSize:10,color:'#94a3b8',flex:1,textAlign:'right'}}>자가 판단 기준 (선택)</div>
      </div>
    </div>
  );
}

// ─── 엔진 동영상 섹션 (Wave 2b — 2026-05-10) ───
// 즉시 업로드 패턴 — POST /cars/:id/videos → car_photos INSERT.
// 출품 시 auctions-core.js:218 SELECT 자연 carry → 마당 mask type='video' 분기.
// selfInspection state 와 무관 (side effect — DB 직접).
//
// 2026-05-11 fix (advisor Block 2) — 모달 재진입 시 기존 비디오 fetch.
//   useEffect([carId]) → GET /cars/:id/photos → 확장자 video 만 filter → uploaded 초기 채움.
//   부모는 key={carId} 로 강제 remount (Block 1 fix) → 매 carId 변경 시 useEffect 첫 호출.
//   중복 업로드 위험 (사용자가 모달 닫고 같은 차량 다시 선택 시 또 업로드) 차단.
var VIDEO_EXT_RE=/\.(mp4|mov|avi|webm|3gp|m4v)$/i;
function EngineVideoSection(props){
  var carId=props.carId;
  var [uploading,setUploading]=useState(false);
  var [uploaded,setUploaded]=useState([]);
  var [error,setError]=useState('');
  var [loading,setLoading]=useState(false);
  var fileRef=useRef(null);

  // 모달 재진입 시 기존 비디오 fetch (Block 2 fix). cancelled flag 로 race 차단.
  React.useEffect(function(){
    if(!carId)return;
    var cancelled=false;
    setLoading(true);
    authFetch(API+'/cars/'+carId+'/photos')
      .then(function(r){return r.json()})
      .then(function(d){
        if(cancelled)return;
        if(d&&d.success&&Array.isArray(d.photos)){
          // 확장자 filter — 비디오만. size 정보 없음 (fetch 응답엔 미포함) → null.
          var videos=d.photos.filter(function(p){return p&&p.fileName&&VIDEO_EXT_RE.test(p.fileName)});
          setUploaded(videos.map(function(p){return {id:p.id,fileName:p.fileName,size:null}}));
        }
      })
      .catch(function(){/* fetch 실패 — silent (업로드 자체는 가능, 사용자는 빈 상태로 봄) */})
      .then(function(){if(!cancelled)setLoading(false)});
    return function(){cancelled=true};
  // eslint-disable-next-line react-hooks/exhaustive-deps
  },[carId]);

  var pickFile=function(){
    if(!carId){setError('차량 선택이 필요합니다');return}
    if(fileRef.current)fileRef.current.click();
  };

  var handleSelect=function(e){
    var file=e.target.files&&e.target.files[0];
    if(!file)return;
    e.target.value='';
    if(!file.type||file.type.indexOf('video/')!==0){setError('동영상 파일만 가능');return}
    if(file.size>100*1024*1024){setError('파일 크기 100MB 초과');return}
    setError('');setUploading(true);
    var fd=new FormData();fd.append('video',file);
    authFetch(API+'/cars/'+carId+'/videos',{method:'POST',body:fd})
      .then(function(r){return r.json()})
      .then(function(d){
        if(d&&d.success){
          setUploaded(function(prev){return prev.concat([{id:d.id,fileName:d.fileName,size:file.size}])});
        }else{
          setError((d&&d.error)||'업로드 실패');
        }
      })
      .catch(function(){setError('네트워크 오류')})
      .then(function(){setUploading(false)});
  };

  var handleDelete=function(photoId){
    authFetch(API+'/cars/photos/'+photoId,{method:'DELETE'})
      .then(function(){setUploaded(function(prev){return prev.filter(function(p){return p.id!==photoId})})});
  };

  return (
    <div style={{padding:'12px',background:'#f8fafc',borderRadius:8,border:'1px solid #e2e8f0'}}>
      <div style={{fontSize:11,fontWeight:700,color:'#475569',marginBottom:6,display:'flex',alignItems:'center',justifyContent:'space-between',flexWrap:'wrap',gap:4}}>
        <span>🎥 엔진 동영상 (선택)</span>
        <span style={{fontSize:9,color:'#94a3b8',fontWeight:500}}>10초 권장 · mp4/mov/webm/avi · 최대 100MB</span>
      </div>
      <input ref={fileRef} type="file" accept="video/*" onChange={handleSelect} style={{display:'none'}}/>
      <button type="button" onClick={pickFile} disabled={uploading||loading||!carId}
        style={{width:'100%',padding:'10px 12px',background:(uploading||loading)?'#cbd5e1':'#fff',border:'2px dashed '+((uploading||loading)?'#cbd5e1':'#3B8BD4'),borderRadius:8,fontSize:12,fontWeight:700,color:(uploading||loading)?'#94a3b8':'#3B8BD4',cursor:(uploading||loading)?'wait':(!carId?'not-allowed':'pointer')}}>
        {loading?'기존 동영상 확인 중...':uploading?'업로드 중...':'+ 엔진 동영상 추가'}
      </button>
      {uploaded.length>0&&(
        <div style={{marginTop:8,display:'flex',flexDirection:'column',gap:4}}>
          {uploaded.map(function(v){
            return (
              <div key={v.id} style={{padding:'6px 10px',background:'#f0f9ff',border:'1px solid #bfdbfe',borderRadius:6,fontSize:11,display:'flex',alignItems:'center',justifyContent:'space-between',gap:8}}>
                <span style={{color:'#1e40af',fontWeight:600,overflow:'hidden',textOverflow:'ellipsis',whiteSpace:'nowrap'}}>✓ {v.fileName}</span>
                {v.size!=null&&<span style={{color:'#64748b',fontSize:10,whiteSpace:'nowrap'}}>{(v.size/1024/1024).toFixed(1)}MB</span>}
                <button type="button" onClick={function(){handleDelete(v.id)}} style={{background:'none',border:'none',color:'#ef4444',fontSize:11,cursor:'pointer',padding:0,fontWeight:600}}>삭제</button>
              </div>
            );
          })}
        </div>
      )}
      {error&&<div style={{marginTop:6,padding:'6px 10px',background:'#fef2f2',border:'1px solid #fecaca',borderRadius:6,fontSize:11,color:'#dc2626'}}>{error}</div>}
    </div>
  );
}

export default AuctionSelfInspection;
